export type DisablePostForEntry = {
  readonly flagName: string;
  readonly toastMessage: string;
};

export function getDisablePostForFlags(): readonly DisablePostForEntry[] {
  return [
    {
      // Disables VacationBalanceImport and AbsenceRegistrationImport via DisabledOperationService
      flagName: 'disable-post-for-calendar',
      toastMessage: $localize`Import vacation balances and Import absences are temporarily unavailable.`,
    },
    {
      // Disables EndFixedTransactions and EditFixedTransactions via DisabledOperationService
      flagName: 'disable-post-for-transaction',
      toastMessage: $localize`End fixed transactions and Edit fixed transactions are temporarily unavailable.`,
    },
    {
      // Disables Tags management (route guard and settings card) via company-routing.module.ts and settings-grid.component.ts
      flagName: 'disable-post-for-org',
      toastMessage: $localize`Tags are temporarily unavailable.`,
    },
    {
      // Disables Cost unit management in settings via settings-grid.component.ts
      flagName: 'disable-post-for-accounts',
      toastMessage: $localize`Cost unit management is temporarily unavailable.`,
    },
    {
      // Disables SalaryUpdateV2, PositionTagsUpdate, EditPositionEndDates, AssignUser, ChangeManager, PayRateUpdate,
      // AssignUnion, employee card, and hiring via DisabledOperationService, route guards, and template directives
      flagName: 'disable-post-for-employee',
      toastMessage: $localize`Employee-related services are temporarily unavailable.`,
    },
  ];
}
